import { formatDisplayPrice } from '@whoop/i18n/utils/priceHelpers';
import { Variant } from 'services/generated/commerce-service/models/Variant';
import {
  getPriceValues,
  getVariantColor,
  isWywVariant,
} from 'ui/utils/variantHelpers';
import { i18n } from '@whoop/i18n/lang/client';
import { Currency } from '@whoop/i18n/types/internationalization';

/**
 * @description Returns a formatted name and price for a given variant.
 * This should be a much dumber component that just displays the price and name of a variant
 * @param defaultVariant {Variant} Default is onyx device
 * @param productVariant {Variant} The a variant
 * @param currency
 * @returns {Element}
 */
export const formattedNameAndPriceForVariant = (
  defaultVariant: Variant,
  productVariant: Variant | null,
  currency: Currency,
) => {
  if (!productVariant && !defaultVariant) return null;

  const swatchToRender = productVariant || defaultVariant;

  const { t } = i18n;

  if (isWywVariant(swatchToRender)) {
    return (
      <p className='text-sm font-bold uppercase tracking-wider'>
        <span className='font-semibold'>+ </span>
        {t('joinLandingPage:whoopYourWay')}
      </p>
    );
  }

  const { displayPrice, originalPrice, isDiscounted, percentSavings } =
    getPriceValues(swatchToRender);

  const formattedDisplayPrice = formatDisplayPrice(
    displayPrice ?? 0,
    currency,
    {
      roundUp: true,
    },
  );

  const formattedOriginalPrice = formatDisplayPrice(
    originalPrice ?? 0,
    currency,
    {
      roundUp: true,
    },
  );

  const isDefaultProduct =
    productVariant?.sku === defaultVariant.sku || !productVariant;

  return (
    <div className='flex justify-start uppercase'>
      <p className='pr-2 text-sm uppercase tracking-wider'>
        <span className='font-bold'>
          {isDefaultProduct ? null : <span className='font-semibold'>+ </span>}
          {getVariantColor(swatchToRender)}
        </span>
        <span>
          &nbsp;
          {isDefaultProduct ? (
            <>
              <span className='font-bold'>SUPERKNIT&nbsp;</span>
              {t('joinLandingPage:included')}
            </>
          ) : (
            formattedDisplayPrice
          )}
        </span>
      </p>
      <span className='text-gray-b50 pr-2 text-sm uppercase tracking-wide line-through'>
        {!isDefaultProduct && isDiscounted ? formattedOriginalPrice : null}
      </span>
      {isDiscounted && percentSavings ? (
        <p className='text-blue-strain whitespace-nowrap text-sm font-semibold uppercase tracking-wide'>
          {t('joinLandingPage:savePercent', { percent: percentSavings })}
        </p>
      ) : null}
    </div>
  );
};
